import { RadnoVrijemeGpsEvdInterface } from "./RadnoVrijemeGpsEvd.resources";

export const RadnoVrijemeGpsEvdResourceDE: RadnoVrijemeGpsEvdInterface = {
  title: "Arbeitszeitnachweis mit GPS-Standort",
  description:
    "Bitte wählen Sie den Zeitraum aus, in dem sich der Arbeitszeitnachweis mit GPS-Standort befindet.",
  addButton: "Hinzufügen",
  gpsPermissionMessage:
    "Bitte erlauben Sie den Zugriff auf den GPS-Standort, damit Sie die Arbeitszeit erfassen können. Der GPS-Standort ist für die Arbeitszeiterfassung erforderlich.",
  gpsError: "Fehler beim Abrufen des GPS-Standorts. Bitte überprüfen Sie die Berechtigungen und versuchen Sie es erneut.",
  gpsNotAvailable: "GPS-Standort ist nicht verfügbar. Bitte aktivieren Sie den Zugriff auf den GPS-Standort.",
  inputFields: {
    startDate: {
      label: "Startdatum",
    },
    endDate: {
      label: "Enddatum",
    },
    actionType: {
      error: "Bitte wählen Sie den Aktionstyp aus.",
      label: "Aktionstyp",
      name: "actionType",
      placeholder: "Aktionstyp auswählen",
    },
  },
  errors: {
    errorLoading:
      "Beim Laden des Arbeitszeitnachweises mit GPS-Standort ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorCreating:
      "Beim Erstellen des Arbeitszeitnachweises mit GPS-Standort ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorDeleting:
      "Beim Löschen des Arbeitszeitnachweises mit GPS-Standort ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorMissingFields:
      "Bitte wählen Sie den Aktionstyp aus und erlauben Sie den Zugriff auf den GPS-Standort.",
  },
  actionTypes: {
    placeholder: "Aktionstyp auswählen",
    startWork: "Arbeitsbeginn",
    takeBreak: "Pausenbeginn",
    endBreak: "Pausenende",
    endWorkDay: "Arbeitsende",
  },
  successModal: {
    title: "Erfolgreich zur Datenbank hinzugefügt",
    body: "Der Arbeitszeiteintrag mit GPS-Standort wurde erfolgreich gespeichert.",
    buttonOk: "OK",
  },
  timestampLabel: "Zeit:",
  locationLabel: "Standort:",
  noLocation: "Standort nicht verfügbar",
};

